import { api } from '../../../services/api/apiClient';
import { crudService } from '../../../services/api/crudService';
import type { ApiResponse } from '../../../types/api';
import type { AllocateInput, Transaction, TransactionInput } from '../types/transactionTypes';

const base = crudService<Transaction, TransactionInput>('/transactions');

/** Payments in and out. There is no edit or delete: a wrong entry is reversed. */
export const transactionService = {
  list: base.list,
  get: base.get,
  create: base.create,
  reverse: (id: string, reason: string) => api.post<ApiResponse<Transaction>>(`/transactions/${id}/reverse`, { reason }).then((r) => r.data),
  allocate: (id: string, body: AllocateInput) => api.post<ApiResponse<Transaction>>(`/transactions/${id}/allocate`, body).then((r) => r.data),
};
